<template>
    <div class="main-container">
        <el-form :inline="true" :model="searchForm" size="small" ref="searchForm" @keyup.enter.native="handleSearch"
            label-width="90px">
            <el-form-item label="账户名" prop="username">
                <el-input v-model="searchForm.username" placeholder="账户名" style="width: 210px"></el-input>
            </el-form-item>
            <el-form-item label="提现状态" prop="applyStatus">
                <el-select v-model="searchForm.applyStatus" placeholder="请选择" style="width: 120px">
                    <el-option label="待审核" :value="0"></el-option>
                    <el-option label="到账成功" :value="1"></el-option>
                    <el-option label="驳回" :value="2"></el-option>
                    <el-option label="处理中" :value="5"></el-option>
                    <el-option label="到账失败" :value="6"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="到账方式" prop="destination">
                <el-select v-model="searchForm.destination" placeholder="请选择" style="width: 120px">
                    <el-option label="微信" :value="0"></el-option>
                    <el-option label="银行卡" :value="1"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="申请时间" prop="selectTime">
                <el-date-picker v-model="selectTime" type="daterange" value-format="yyyy-MM-dd" format="yyyy-MM-dd"
                    key="picker1" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"  style="width: 230px"
                    @change="handleChangeDate"></el-date-picker>
            </el-form-item>
            <el-form-item label="处理时间" prop="selectTime">
                <el-date-picker v-model="selectTime1" type="daterange" value-format="yyyy-MM-dd" format="yyyy-MM-dd"
                    key="picker1" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"  style="width: 230px"
                    @change="handleChangeDate1"></el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="handleSearch" size="small">查询</el-button>
                <el-button @click="handleReset" size="small">重置</el-button>
            </el-form-item>
        </el-form>

        <div class="device_statics">
            <div class="device_count">
                <div>提现金额(元)</div>
                <div><span>{{totalData.totalPayment || 0}}</span></div>
            </div>
             <div class="device_money">
                <div>提现笔数(笔)</div>
                <div><span>{{totalData.totalSize || 0}}</span></div>
            </div>
            <div class="device_count">
                <div>未处理(笔)</div>
                <div><span>{{totalData.noHandleSize || 0}}</span></div>
            </div>

        </div>

        <el-table border size="small" style="width:100%;margin-top:10px;" :data="tableData" v-loading="isLoading"
            element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)">
            <el-table-column type="index" label="#" align="center"></el-table-column>
            <el-table-column prop="createTime" label="创建时间"  width="170"></el-table-column>
            <el-table-column prop="username" label="账户名" width="150"></el-table-column>
            <el-table-column prop="amount" label="金额" width="100"></el-table-column>
            <el-table-column prop="withdrawFee" label="手续费" width="100"></el-table-column>
            <el-table-column prop="destinationDesc" label="到账方式" width="100">
                <template slot-scope="{ row }">
                    <el-tag v-if="row.destination == 0">微信</el-tag>
                    <el-tag type="success" v-if="row.destination == 1">银行卡</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="applyStatusDesc" label="提现状态" width="100">
                <template slot-scope="{ row }">
                    <el-tag type="danger" v-if="row.applyStatus == 2 || row.applyStatus == 6">{{ row.applyStatusDesc }}</el-tag>
                    <el-tag v-else>{{ row.applyStatusDesc }}</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="rejectDesc" label="驳回描述" width="150" show-overflow-tooltip></el-table-column>
            <el-table-column prop="reason" label="原因" width="250" show-overflow-tooltip></el-table-column>
            <el-table-column prop="openId" label="openid" width="150"></el-table-column>
            <el-table-column prop="bankCard" label="银行卡号" width="180"></el-table-column>
            <el-table-column prop="bankName" label="银行" width="120"></el-table-column>
            <el-table-column prop="bankBranch" label="支行网点" width="280" show-overflow-tooltip></el-table-column>
            <el-table-column prop="realName" label="真实姓名" width="100"></el-table-column>
            
            <el-table-column label="操作" fixed="right" width="120">
                <template slot-scope="{ row }">
                    <el-button size="mini" type="text" v-if="pagePermission.includes('aduit') && (row.couldAudit) && (row.applyStatus == 0 || row.applyStatus == 6)" @click="handleEditHotel(row)">审核</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination @size-change="handleChangeSize" @current-change="handleChangePage"
            style="text-align:right;margin-top:10px;" :current-page="searchForm.pageNumber" :page-sizes="[10, 20, 50]"
            :page-size="searchForm.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>

        <el-drawer title="审核" :visible.sync="isShow" size="950px">
            
            <el-form ref="modelForm" :model="modelForm" inline label-width="110px" class="model_container"
                style="margin:0 20px" size="small" :rules="modelFormRules">
                <el-form-item label="账户名" prop="username">
                    <el-input type="text" v-model="modelForm.username" disabled style="width: 250px"></el-input>
                </el-form-item>
                <el-form-item label="银行卡号" prop="bankCard">
                    <el-input type="text" v-model="modelForm.bankCard" disabled style="width: 250px"></el-input>
                </el-form-item>
                <el-form-item label="所属银行" prop="bankName">
                    <el-input type="text" v-model="modelForm.bankName" disabled style="width: 250px"></el-input>
                </el-form-item>
                <el-form-item label="支行网点" prop="bankBranch">
                    <el-input type="text" v-model="modelForm.bankBranch" disabled style="width: 250px"></el-input>
                </el-form-item>
                <el-form-item label="真实姓名" prop="realName">
                    <el-input v-model="modelForm.realName" disabled style="width: 250px"></el-input>
                </el-form-item>

                <el-form-item label="提现金额" prop="amount">
                    <el-input v-model="modelForm.amount" disabled style="width: 250px"></el-input>
                </el-form-item>

                <el-form-item label="到账方式" prop="destinationDesc">
                    <el-input :value="modelForm.destination == 0 ?'微信' : '银行卡'" disabled style="width: 250px"></el-input>
                </el-form-item>
                <div class="line"></div>

                <div>
                    <el-form-item label="审核" prop="status">
                        <el-radio-group v-model="modelForm.status" style="width: 250px">
                            <el-radio label="PASS">通过</el-radio>
                            <el-radio label="REJECT">驳回</el-radio>
                        </el-radio-group>
                    </el-form-item>

                    <el-form-item label="驳回描述" prop="msg" v-if="modelForm.status == 'REJECT'">
                        <el-input type="textarea" v-model="modelForm.msg" placeholder="请输入驳回描述" style="width: 250px"></el-input>
                    </el-form-item>
                </div>

            </el-form>

            <div class="footer" style="margin:0 20px;text-align:right;">
                <el-button type="text" @click="isShow = false">取消</el-button>
                <el-button type="primary" size="small" :loading="submitLoading" @click="handleSubmit('modelForm')">提交</el-button>
            </div>
        </el-drawer>
    </div>
</template>

<script>
import {cloneDeep } from "lodash";
import qs from "qs";
export default {
    name: "hotelManage",
    computed: {
        pagePermission() {
            return this.$store.state.pagePermission;
        },
        headers() {
            return {
                "Authorization": localStorage.getItem('Token'),
            }
        },
    },
    data() {

        return {
            totalData: {},
            searchForm: {
                username: "",
                applyStatus: "",
                destination: "",
                startDate: "",
                endDate: "",
                endDate: "",
                timeStart: "",
                pageSize: 10,
                pageNumber: 1,
            },
            selectTime: null,
            selectTime1: null,
            isLoading: false,
            tableData: [],
            total: 0,
            isShow: false,
            submitLoading: false,
            modelForm: {
                staus: "",
                username: "",
                msg: ""
            },
            modelFormRules: {
                status: [{ required: true, message: "请选择审核状态", trigger: "blur" }],
                msg: [{ required: true, message: "请输入驳回备注", trigger: "blur" }],
            },

        }
    },
    methods: {
        handleSubmit(fromName) {
            this.$refs[fromName].validate(valid => {
                if (valid) {
                    this.submitLoading = true;
                    this.postRequest(`/withdraw/record/audit?${qs.stringify({
                        id: this.modelForm.id,
                        status: this.modelForm.status,
                        msg: this.modelForm.msg
                    })}`)
                    .then(res => {
                        this.submitLoading = false;
                        let data = res.data;
                        if (data.code == 200) {
                            this.$message.success(data.msg);
                            this.isShow = false;
                            this.getTableData();
                            this.getTotalData();
                            
                        }
                    }).catch(() => {
                        this.submitLoading = false;
                    })
                }
            })
        },
        handleEditHotel(item) {
            this.modelForm = cloneDeep(item);
            this.isShow = true;
        },
     
        handleSearch() {
            this.searchForm.pageNumber = 1;
            this.getTableData();
            this.getTotalData();

        },

        handleReset() {
            this.searchForm = {
                username: "",
                applyStatus: "",
                destination: "",
                startDate: "",
                endDate: "",
                timeStart: "",
                timeEnd: "",
                pageSize: 10,
                pageNumber: 1,
            };
            this.selectTime = '',
            this.selectTime1 = '',
            this.getTableData();
            this.getTotalData();
        },

        handleChangeDate(date) {
            if (date.length) {
                this.searchForm.startDate = date[0];
                this.searchForm.endDate = date[1];
            }
        },
        handleChangeDate1(date) {
            if (date.length) {
                this.searchForm.timeStart = date[0];
                this.searchForm.timeEnd = date[1];
            }
        },
        handleChangePage(page) {
            this.searchForm.pageNumber = page;
            this.getTableData();
        },

        handleChangeSize(size) {
            this.searchForm.pageNumber = 1;
            this.searchForm.pageSize = size;
            this.getTableData();
        },
        getTableData() {
            this.isLoading = true;
            this.getRequest("/withdraw/record/pageList", this.searchForm)
                .then(res => {
                    this.isLoading = false;
                    let data = res.data;
                    if (data.code == 200) {
                        this.tableData = data.data.records;
                        this.total = data.data.total;
                    }
                }).catch(() => {
                    this.isLoading = false;
                })
        },
        getTotalData() {
            this.getRequest("/withdraw/record/sumList", this.searchForm)
                .then(res => {
                    this.isLoading = false;
                    let data = res.data;
                    if (data.code == 200) {
                        this.totalData = data.data;
                    }
                })
        }
    },

    mounted() {
        this.getTableData();
        this.getTotalData();
    },

}
</script>

<style type="less">
    @import url("./index.less");
</style>